import React, { FC, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

import modalBase from '../../../ModalBase/ModalBase.module.scss';
import classes from './ModalAutoDistributeWarning.module.scss';
import { OperatorPresence } from '../../../../hooks/Agents/useOperatorPresence';

const COUNTDOWN_SECONDS = 10;

const MANUAL_PRESENCE: { value: OperatorPresence; label: string }[] = [
  { value: 'FREE', label: 'Свободен' },
  { value: 'BUSY', label: 'Занят' },
  { value: 'BREAK', label: 'Перерыв' },
];

type ModalAutoDistributeWarningProps = {
  isActive: boolean;
  isUpdating?: boolean;
  onSelectPresence: (presence: OperatorPresence) => void;
  onCountdownComplete: () => void;
};

const ModalAutoDistributeWarning: FC<ModalAutoDistributeWarningProps> = ({
  isActive,
  isUpdating,
  onSelectPresence,
  onCountdownComplete,
}) => {
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);
  const resolvedRef = useRef(false);

  useEffect(() => {
    if (!isActive) {
      return;
    }
    resolvedRef.current = false;
    setSecondsLeft(COUNTDOWN_SECONDS);
    const id = window.setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          window.clearInterval(id);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => window.clearInterval(id);
  }, [isActive]);

  useEffect(() => {
    if (!isActive || secondsLeft !== 0 || resolvedRef.current) {
      return;
    }
    resolvedRef.current = true;
    onCountdownComplete();
  }, [isActive, secondsLeft, onCountdownComplete]);

  const handleSelect = (presence: OperatorPresence) => {
    if (resolvedRef.current || isUpdating) {
      return;
    }
    resolvedRef.current = true;
    onSelectPresence(presence);
  };

  return (
    <div className={classNames(modalBase.modal, { [modalBase.active]: isActive })}>
      <div
        className={classNames(modalBase.container, classes.modalContainer)}
        onClick={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()}>
        <h2 className={classes.title}>Автораспределение талонов</h2>
        <p className={classes.warning}>
          Включено автораспределение талонов на свободных операторов. Через указанное время ваш
          статус станет «Свободен», и система сможет автоматически направить вам следующий талон.
          Вы можете заранее выбрать другой статус.
        </p>
        <div className={classes.countdown}>{secondsLeft}</div>
        <p className={classes.countdownHint}>
          до статуса «Свободен» для автовызова
        </p>
        <div className={classes.statusButtons}>
          {MANUAL_PRESENCE.map((item) => (
            <button
              key={item.value}
              type="button"
              className={classes.statusBtn}
              disabled={isUpdating}
              onClick={() => handleSelect(item.value)}>
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ModalAutoDistributeWarning;
